import { Navigate } from "react-router-dom";
import { useAuth, canAccess } from "../context/AuthContext";

export default function ProtectedRoute({ children, module }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 font-display" data-testid="loading-auth">Memuat sesi...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (module && !canAccess(user.role, module)) return <Navigate to="/dashboard" replace />;
  return children;
}
